module.exports = __webpack_public_path__ + "img/TeamViewer.ef32699.svg";